import React, { useState } from 'react'
import {
    Grid,
    Box,
    InputLabel,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel
} from "@mui/material"
import { styled } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment"
import SelectCmp from "react-select"
import { toastError } from '../../../utils';
import ClearIcon from '@mui/icons-material/Clear';
import { staticGenre, trackTitleLanguage } from '../../../constants';
import { priceForEP, priceForSingle, priceForAlbum } from "../../../constants";
import CustomShowModal from '../../Common/CustomShowModal';

const selectStyles = {
    control: (base, state) => ({
        ...base,
        background: '#ffffff',
        borderRadius: '8px',
        borderColor: state.isFocused ? '#1a73e8' : 'rgba(0, 0, 0, 0.12)',
        borderWidth: state.isFocused ? '2px' : '1px',
        boxShadow: 'none',
        '&:hover': {
            borderColor: 'rgba(26, 115, 232, 0.3)',
        },
    }),
    singleValue: (base) => ({
        ...base,
        color: '#202124',
        fontFamily: `"DM Sans", sans-serif`
    }),
    placeholder: (base) => ({
        ...base,
        color: '#5f6368',
        fontFamily: `"DM Sans", sans-serif`
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#1a73e8' : state.isFocused ? 'rgba(26, 115, 232, 0.08)' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#202124',
        fontFamily: `"DM Sans", sans-serif`,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(26, 115, 232, 0.08)',
        },
    }),
    input: (base) => ({
        ...base,
        color: '#202124',
    }),
}

const CssTextField = styled(TextField)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    '& .MuiOutlinedInput-root': {
        background: '#ffffff',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
        '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(26, 115, 232, 0.3)',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#1a73e8',
            borderWidth: '2px',
        },
    },
    '& .MuiOutlinedInput-input': {
        color: '#202124',
    },
    '& label': {
        color: '#5f6368',
        fontFamily: "'DM Sans', sans-serif",
    },
    '& label.Mui-focused': {
        color: '#1a73e8',
    },
}));

const StyledInputLabel = styled(InputLabel)({
    color: '#202124 !important',
    fontWeight: 600,
    marginBottom: '8px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.95rem',
});

const StyledFormControlLabel = styled(FormControlLabel)({
    '& .MuiFormControlLabel-label': {
        color: '#202124 !important',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.95rem',
    },
    '& .MuiRadio-root': {
        color: '#1a73e8',
    },
});

function SongDetailForm(props) {

    const {
        songInfo,
        setSongInfo,
        primaryArtist = [],
        setOpenAddFeaturing,
        setOpenAddPrimary,
        featuringArtist,
        addArtist,
        releaseInfo,
        setAddArtist,
        selectedSongPrimaryArtist,
        setSelectedSongPrimaryArtist,
        selectedSongfeaturingArtist,
        setSelectedSongfeaturingArtist,
        selectedSongAuthor,
        setSelectedSongAuthor,
        selectedSongComposer,
        setSelectedSongComposer
    } = props;

    let priceOptions = []
    if (releaseInfo.release_type === 'ep') {
        priceOptions = priceForEP
    } else if (releaseInfo.release_type === 'single') {
        priceOptions = priceForSingle
    } else {
        priceOptions = priceForAlbum
    }

    const [selectedDate, setSelectedDate] = useState(songInfo.production_year)
    const [openModal, setOpenModal] = useState(false)

    const onChangeHandler = (e) => {
        let { value, name } = e.target;
        if (name === 'caller_tune') {
            if (String(value).length > 8) return
            value = String(value).replace(/:/g, "");
            if (isNaN(Number(value))) {
                return
            }
            let newValue = ''
            for (let i = 0; i < value.toString().length; i++) {
                if (i === 2 || i === 4) {
                    newValue = newValue + ":"
                }
                newValue = newValue + String(value).charAt(i)

            }
            value = newValue
        }

        if (name === 'destribute_music' && value === 'No') {
            setSongInfo({ ...songInfo, video_isrc: '', download_video_link: '', [name]: value })
        } else {
            setSongInfo({ ...songInfo, [name]: value })
        }
    }

    const onChangeSelect = (e, type) => {
        if (type === 'primary') {
            const isExists = selectedSongPrimaryArtist.find(item => item.artist_id === e.artist_id)
            if (isExists) {
                return toastError("This artist is already added.")
            }
            if (selectedSongfeaturingArtist.length === 1 && selectedSongPrimaryArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedSongfeaturingArtist.length === 2 && selectedSongPrimaryArtist.length > 0) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedSongPrimaryArtist.length > 2) {
                return toastError("Maximum artist limit reached")
            }
            setSelectedSongPrimaryArtist([...selectedSongPrimaryArtist, e])
        } else if (type === 'featuring') {
            const isExists = selectedSongfeaturingArtist.find(item => item.artist_id === e.artist_id)
            if (isExists) {
                return toastError("This artist is already added.")
            }
            if (selectedSongfeaturingArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedSongPrimaryArtist.length === 1 && selectedSongfeaturingArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedSongPrimaryArtist.length === 2 && selectedSongfeaturingArtist.length > 0) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedSongPrimaryArtist.length === 3) {
                return toastError("Maximum artist limit reached")
            }
            setSelectedSongfeaturingArtist([...selectedSongfeaturingArtist, e])
        } else if (type === 'author') {
            const isExists = selectedSongAuthor && selectedSongAuthor.find(item => item.firstName === e.firstName && item.lastName === e.lastName)
            if (isExists) {
                return toastError("This author is already added.")
            }
            if (selectedSongAuthor.length > 2) {
                return toastError("Can't add more author.")
            }
            setSelectedSongAuthor([...selectedSongAuthor, { firstName: e.firstName || '', lastName: e.lastName || '' }])
        } else {
            const isExists = selectedSongComposer && selectedSongComposer.find(item => item.firstName === e.firstName && item.lastName === e.lastName)
            if (isExists) {
                return toastError("This author is already added.")
            }
            if (selectedSongComposer.length > 2) {
                return toastError("Can't add more author.")
            }
            setSelectedSongComposer([...selectedSongComposer, { firstName: e.firstName || '', lastName: e.lastName || '' }])
        }
    }

    const removeSelectedPrimary = (type, index) => {
        if (type === "primary") {
            let newArr = [...selectedSongPrimaryArtist]
            newArr.splice(index, 1)
            setSelectedSongPrimaryArtist(newArr)
        } else if (type === "featuring") {
            let newArr = [...selectedSongfeaturingArtist]
            newArr.splice(index, 1)
            setSelectedSongfeaturingArtist(newArr)
        } else if (type === "author") {
            let newArr = [...selectedSongAuthor]
            newArr.splice(index, 1)
            setSelectedSongAuthor(newArr)
        } else {
            let newArr = [...selectedSongComposer]
            newArr.splice(index, 1)
            setSelectedSongComposer(newArr)
        }
    }

    const onTypeSelectField = (type, e, index, field) => {
        const value = e.target.value;
        // Allow only letters, spaces, hyphens, and apostrophes (common in names)
        const nameRegex = /^[a-zA-Z\s'-]*$/;

        if (!nameRegex.test(value)) {
            return toastError('Special characters are not allowed.');
        }

        if (type === 'author') {
            let newSelected = [...selectedSongAuthor]
            newSelected[index][field] = value
            setSelectedSongAuthor(newSelected)
        } else {
            let newSelected = [...selectedSongComposer]
            newSelected[index][field] = value
            setSelectedSongComposer(newSelected)
        }
    }

    const selectedGenre = staticGenre.find(item => item.value === songInfo.genre)
    const selectedPriceTier = priceOptions.find(item => item.value === songInfo.price_tier)
    const selectedTrackTitle = trackTitleLanguage.find(item => item.value === songInfo.track_title_language)
    const selectedLyrics = trackTitleLanguage.find(item => item.value === songInfo.lyrics_language)

    // Check if all existing lyricists have both firstName and lastName filled
    const canAddAuthor = selectedSongAuthor.every(author =>
        author.firstName && author.firstName.trim() !== '' &&
        author.lastName && author.lastName.trim() !== ''
    );

    // Check if all existing composers have both firstName and lastName filled
    const canAddComposer = selectedSongComposer.every(composer =>
        composer.firstName && composer.firstName.trim() !== '' &&
        composer.lastName && composer.lastName.trim() !== ''
    );


    return (
        <Grid container spacing={3} className="add-song-details-container">
            {/* Left Column */}
            <Grid item xs={12} md={6}>
                <Grid container>
                    <Grid item xs={12}>
                        <Box p={1}>
                            <StyledInputLabel>Track Version<span className="required-span">*</span></StyledInputLabel>
                            <RadioGroup name="track_version" value={songInfo.track_version} onChange={onChangeHandler} row>
                                <StyledFormControlLabel value="Original" control={<Radio />} label="Original" />
                                <StyledFormControlLabel value="Karaoke" control={<Radio />} label="Karaoke" />
                                <StyledFormControlLabel value="Medley" control={<Radio />} label="Medley" />
                                <StyledFormControlLabel value="Cover" control={<Radio />} label="Cover" />
                            </RadioGroup>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box p={1}>
                            <StyledInputLabel>Instrumental<span className="required-span">*</span></StyledInputLabel>
                            <RadioGroup name="instrumental" value={songInfo.instrumental} onChange={onChangeHandler} row>
                                <StyledFormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <StyledFormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Title<span className="required-span">*</span></StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="Title"
                        size="small"
                        name="title"
                        value={songInfo.title}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Version/Subtitle</StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="Version Subtitle"
                        size="small"
                        name="version_subtitle"
                        value={songInfo.version_subtitle}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Primary Artist<span className="required-span">*</span></StyledInputLabel>
                    <Grid container>
                        <Grid item xs={11}>
                            <SelectCmp
                                styles={selectStyles}
                                options={primaryArtist}
                                placeholder="Select Primary Artist"
                                onChange={(e) => onChangeSelect(e, "primary")}
                            />

                        </Grid>
                        <Grid item xs={1} style={{ alignSelf: "center" }}>
                            <AddIcon
                                className="add-icon-button"
                                onClick={() => { setAddArtist({ ...addArtist, 'artist_type': "primary" }); setOpenAddPrimary(true) }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container>
                        {
                            selectedSongPrimaryArtist.map((item, key) => <Grid item xs={12} key={key}>
                                <Box display="flex" justifyContent="space-between" p={1}>
                                    <div style={{ fontSize: "12px", display: "flex", color: '#202124' }}>
                                        <div><p style={{ fontWeight: 600, marginRight: 5, color: '#202124' }}>{key + 1}.</p></div>
                                        <div>
                                            <p style={{ fontWeight: 600, color: '#202124' }}>Artist Name: {item.artist_name}</p>
                                            <p style={{ color: '#5f6368' }}>Apple Id: {item.apple_id}</p>
                                            <p style={{ color: '#5f6368' }}>Spotify Id: {item.spotify_id}</p>

                                        </div>
                                    </div>
                                    <div><ClearIcon onClick={() => removeSelectedPrimary("primary", key)} style={{ cursor: 'pointer', color: '#f44336' }} /></div>
                                </Box>
                            </Grid>)
                        }
                    </Grid>

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Featuring Artist</StyledInputLabel>
                    <Grid container>
                        <Grid item xs={11}>
                            <SelectCmp
                                styles={selectStyles}
                                options={featuringArtist}
                                placeholder="Select Featuring Artist"
                                onChange={(e) => onChangeSelect(e, "featuring")}
                            />

                        </Grid>
                        <Grid item xs={1} style={{ alignSelf: "center" }}>
                            <AddIcon
                                className="add-icon-button"
                                onClick={() => { setAddArtist({ ...addArtist, 'artist_type': "featuring" }); setOpenAddFeaturing(true) }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container>
                        {
                            selectedSongfeaturingArtist.map((item, key) => <Grid item xs={12} key={key}>
                                <Box display="flex" justifyContent="space-between" p={1}>
                                    <div style={{ fontSize: "12px", display: "flex", color: '#202124' }}>
                                        <div><p style={{ fontWeight: 600, marginRight: 5, color: '#202124' }}>{key + 1}.</p></div>
                                        <div>
                                            <p style={{ fontWeight: 600, color: '#202124' }}>Artist Name: {item.artist_name}</p>
                                            <p style={{ color: '#5f6368' }}>Apple Id: {item.apple_id}</p>
                                            <p style={{ color: '#5f6368' }}>Spotify Id: {item.spotify_id}</p>

                                        </div>
                                    </div>
                                    <div><ClearIcon onClick={() => removeSelectedPrimary("featuring", key)} style={{ cursor: 'pointer', color: '#f44336' }} /></div>
                                </Box>
                            </Grid>)
                        }
                    </Grid>

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Lyricist<span className="required-span">*</span></StyledInputLabel>

                    <Grid container>
                        {
                            selectedSongAuthor.map((item, key) => <React.Fragment key={key}>
                                <Grid item xs={key === 0 ? 12 : 11} >
                                    <Box display="flex" gap={1} justifyContent="space-between">
                                        <CssTextField
                                            variant="outlined"
                                            fullWidth
                                            placeholder="First Name"
                                            size="small"
                                            style={key === 0 ? { marginBottom: 3 } : { margin: '3px 0px' }}
                                            value={item.firstName || ''}
                                            onChange={(e) => onTypeSelectField('author', e, key, 'firstName')}
                                        />
                                        <CssTextField
                                            variant="outlined"
                                            fullWidth
                                            placeholder="Last Name"
                                            size="small"
                                            style={key === 0 ? { marginBottom: 3 } : { margin: '3px 0px' }}
                                            value={item.lastName || ''}
                                            onChange={(e) => onTypeSelectField('author', e, key, 'lastName')}
                                        />
                                    </Box>
                                </Grid>
                                {key === 0 ? null : <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
                                    <ClearIcon onClick={() => removeSelectedPrimary("author", key)} style={{ cursor: 'pointer', color: '#f44336' }} />
                                </Grid>}
                            </React.Fragment>
                            )
                        }
                    </Grid>
                    {selectedSongAuthor.length > 2 ? null : <Grid container>
                        <Box display="flex">
                            <button
                                className="custom-add-more-button"
                                onClick={() => setSelectedSongAuthor([...selectedSongAuthor, { firstName: "", lastName: "" }])}
                                disabled={!canAddAuthor}
                                style={{
                                    opacity: !canAddAuthor ? 0.5 : 1,
                                    cursor: !canAddAuthor ? 'not-allowed' : 'pointer'
                                }}
                            >
                                + Add
                            </button>
                        </Box>
                    </Grid>}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Composer<span className="required-span">*</span></StyledInputLabel>

                    <Grid container>
                        {
                            selectedSongComposer.map((item, key) => <React.Fragment key={key}>
                                <Grid item xs={key === 0 ? 12 : 11} >
                                    <Box display="flex" gap={1} justifyContent="space-between">
                                        <CssTextField
                                            variant="outlined"
                                            fullWidth
                                            placeholder="First Name"
                                            size="small"
                                            style={key === 0 ? { marginBottom: 3 } : { margin: '3px 0px' }}
                                            value={item.firstName || ''}
                                            onChange={(e) => onTypeSelectField('composer', e, key, 'firstName')}
                                        />
                                        <CssTextField
                                            variant="outlined"
                                            fullWidth
                                            placeholder="Last Name"
                                            size="small"
                                            style={key === 0 ? { marginBottom: 3 } : { margin: '3px 0px' }}
                                            value={item.lastName || ''}
                                            onChange={(e) => onTypeSelectField('composer', e, key, 'lastName')}
                                        />
                                    </Box>
                                </Grid>
                                {key === 0 ? null : <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
                                    <ClearIcon onClick={() => removeSelectedPrimary("composer", key)} style={{ cursor: 'pointer', color: '#f44336' }} />
                                </Grid>}
                            </React.Fragment>
                            )
                        }
                    </Grid>
                    {selectedSongComposer.length > 2 ? null : <Grid container>
                        <Box display="flex">
                            <button
                                className="custom-add-more-button"
                                onClick={() => setSelectedSongComposer([...selectedSongComposer, { firstName: "", lastName: "" }])}
                                disabled={!canAddComposer}
                                style={{
                                    opacity: !canAddComposer ? 0.5 : 1,
                                    cursor: !canAddComposer ? 'not-allowed' : 'pointer'
                                }}
                            >
                                + Add
                            </button>
                        </Box>
                    </Grid>}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Music Producer<span className="required-span">*</span></StyledInputLabel>
                    <CssTextField
                        id="ReleaseTitle"
                        variant="outlined"
                        fullWidth
                        placeholder="Music Producer"
                        size="small"
                        name="producer"
                        value={songInfo.producer}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Lyrics</StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="Lyrics"
                        name="lyrics"
                        multiline
                        rows={4}
                        value={songInfo.lyrics}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>
                </Grid>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} md={6}>
                <Grid container>
            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel><i className="fab fa-product-hunt"></i> Line<span className="required-span">*</span></StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="p_line"
                        value={songInfo.p_line}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Production Year<span className="required-span">*</span></StyledInputLabel>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            views={["year"]}
                            format="YYYY"
                            maxDate={moment().add(3, 'y')}
                            value={selectedDate ? moment(selectedDate, 'YYYY') : null}
                            name="production_year"
                            onChange={date => { setSongInfo({ ...songInfo, production_year: date.format('YYYY') }); setSelectedDate(date.format('YYYY')) }}
                            enableAccessibleFieldDOMStructure={false}
                            slots={{
                                textField: (params) => (
                                    <CssTextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder="Select production year"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />
                                )
                            }}
                            slotProps={{
                                openPickerIcon: {
                                    sx: {
                                        color: '#1a73e8',
                                    }
                                },
                                popper: {
                                    sx: {
                                        '& .MuiPaper-root': {
                                            borderRadius: '12px',
                                            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.3)',
                                            background: '#e8eef3',
                                            border: '1px solid rgba(0, 0, 0, 0.2)',
                                        },
                                        '& .MuiPickersYear-yearButton': {
                                            color: '#202124',
                                            fontWeight: 500,
                                            fontSize: '1rem',
                                            '&:hover': {
                                                background: 'rgba(26, 115, 232, 0.2)',
                                            },
                                            '&.Mui-selected': {
                                                background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
                                                color: '#ffffff',
                                                fontWeight: 600,
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
                                                }
                                            },
                                        },
                                        '& .MuiYearCalendar-root': {
                                            color: '#202124',
                                        },
                                        '& .MuiPickersCalendarHeader-root': {
                                            color: '#202124',
                                            background: 'linear-gradient(135deg, rgba(26, 115, 232, 0.15) 0%, rgba(0, 191, 165, 0.15) 100%)',
                                            padding: '16px',
                                            marginBottom: '8px',
                                        },
                                        '& .MuiPickersCalendarHeader-label': {
                                            color: '#202124',
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                        },
                                        '& .MuiPickersArrowSwitcher-button': {
                                            color: '#1a73e8',
                                            '&:hover': {
                                                background: 'rgba(26, 115, 232, 0.15)',
                                            }
                                        },
                                        '& .MuiPickersLayout-root': {
                                            background: '#e8eef3',
                                        }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Publisher</StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="Publisher"
                        size="small"
                        name="publisher"
                        value={songInfo.publisher}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Have Your Own ISRC<span className="required-span">*</span></StyledInputLabel>
                    <RadioGroup name="isrc_yes_no" value={songInfo.isrc_yes_no} onChange={onChangeHandler} row>
                        <StyledFormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <StyledFormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                </Box>
            </Grid>

            {
                songInfo.isrc_yes_no === 'Yes' ? <Grid item xs={12}>
                    <Box p={1}>
                        <StyledInputLabel>ISRC<span className="required-span">*</span></StyledInputLabel>
                        <CssTextField
                            variant="outlined"
                            fullWidth
                            placeholder="ISRC"
                            size="small"
                            name="isrc"
                            value={songInfo.isrc}
                            onChange={onChangeHandler}
                        />

                    </Box>
                </Grid> : null
            }

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Genre<span className="required-span">*</span></StyledInputLabel>
                    <SelectCmp
                        styles={selectStyles}
                        options={staticGenre}
                        value={selectedGenre}
                        placeholder="Select Genre"
                        onChange={e => setSongInfo({ ...songInfo, genre: e.value })}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Sub Genre<span className="required-span">*</span></StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="Sub Genre"
                        size="small"
                        name="subgenre"
                        value={songInfo.subgenre}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Price Tier<span className="required-span">*</span></StyledInputLabel>
                    <SelectCmp
                        styles={selectStyles}
                        value={selectedPriceTier}
                        options={priceOptions}
                        placeholder="Select Price Tier"
                        onChange={e => setSongInfo({ ...songInfo, price_tier: e.value })}
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Explicit Version<span className="required-span">*</span></StyledInputLabel>
                    <RadioGroup name="explicit_version" value={songInfo.explicit_version} onChange={onChangeHandler} row>
                        <StyledFormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <StyledFormControlLabel value="No" control={<Radio />} label="No" />
                        <StyledFormControlLabel value="Cleaned" control={<Radio />} label="Cleaned" />
                    </RadioGroup>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Track Title Language<span className="required-span">*</span></StyledInputLabel>
                    <SelectCmp
                        styles={selectStyles}
                        value={selectedTrackTitle}
                        options={trackTitleLanguage}
                        placeholder="Track Title Language"
                        onChange={e => setSongInfo({ ...songInfo, track_title_language: e.value })}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel htmlFor="ReleaseTitle">Lyrics Language<span className="required-span">*</span></StyledInputLabel>
                    <SelectCmp
                        styles={selectStyles}
                        value={selectedLyrics}
                        options={trackTitleLanguage}
                        placeholder="Lyrics Language"
                        onChange={e => setSongInfo({ ...songInfo, lyrics_language: e.value })}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Caller Tune Timing<span className="required-span">*</span></StyledInputLabel>
                    <CssTextField
                        variant="outlined"
                        fullWidth
                        placeholder="HH:MM:SS"
                        size="small"
                        name="caller_tune"
                        value={songInfo.caller_tune}
                        onChange={onChangeHandler}
                    />

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box p={1}>
                    <StyledInputLabel>Want to distribute music video?</StyledInputLabel>
                    <RadioGroup name="destribute_music" value={songInfo.destribute_music} onChange={onChangeHandler} row>
                        <StyledFormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <StyledFormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                </Box>
            </Grid>

            {
                songInfo.destribute_music === 'Yes' ? <React.Fragment>
                    <Grid item xs={12}>
                        <Box p={1}>
                            <StyledInputLabel>Video ISRC</StyledInputLabel>
                            <CssTextField
                                variant="outlined"
                                fullWidth
                                placeholder="Video ISRC"
                                size="small"
                                name="video_isrc"
                                value={songInfo.video_isrc}
                                onChange={onChangeHandler}
                            />

                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box p={1}>
                            <StyledInputLabel>Download link to video<span className="required-span">*</span></StyledInputLabel>
                            <CssTextField
                                variant="outlined"
                                fullWidth
                                placeholder="Download link to video"
                                size="small"
                                name="download_video_link"
                                value={songInfo.download_video_link}
                                onChange={onChangeHandler}
                            />

                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <p style={{
                            fontSize: '12px',
                            textAlign: 'center',
                            marginTop: '-7px',
                            marginBottom: '12px',
                            color: '#555555'
                        }}>Preferred sites - <a href="https://wetransfer.com/" target="_blank" rel="noreferrer">wetransfer</a>, <a href="https://www.dropbox.com/" target="_blank" rel="noreferrer">Dropbox</a>, <a href="https://www.google.com/intl/en_ca/drive/download/" target="_blank" rel="noreferrer">GoogleDrive</a>, <a href="https://fromsmash.com/" target="_blank" rel="noreferrer">Formsmash</a></p>
                    </Grid>

                    <Grid item xs={12}>
                        <a className="artwork-guidlines" style={{ width: '100%', float: 'right', fontSize: 13, textAlign: 'end', cursor: 'pointer' }} onClick={() => setOpenModal(true)}>MUSIC VIDEO GUIDELINES/SPECIFICATIONS</a>
                    </Grid>

                </React.Fragment> : null
            }
                </Grid>
            </Grid>

            <CustomShowModal
                open={openModal}
                handleClose={() => setOpenModal(false)}
                maxWidth="md"
                title="MUSIC VIDEO GUIDELINES/SPECIFICATIONS"
            >
                <h2 style={{ color: '#202124', fontFamily: "'DM Sans', sans-serif" }}>Music Video Guidelines</h2>
                <p>Graphic Overlays.
                Music videos must not contain chyrons, static or scrolling lyrics, or lower-third graphics.
                <br /><br />
                Release Dates or Advertisements. Music videos must not contain release dates, logos, or advertisements.
                <br /><br />
                Nonstandard Music Videos. Music videos that are artist interviews, commentaries, behind the scenes, or similar in content must be bundled with a music album and cannot be sold individually.
                <br /><br />
                Promotional Still Image Videos. Promotional videos (such as videos displaying only the cover art and audio or slide shows) will not be accepted.
                <br /><br />
                Teasers, Trailers and Partial Videos. Music videos which have been shortened or edited into a promotional teaser, trailer or partial version will not be accepted.
                <br /><br />
                Music Video Quality. Music videos with poor quality (such as glitches, blurriness, incomplete video or audio, no audio, out of sync audio and video, and so on) will not be accepted.
                <br /><br />
                Explicit Content. Music videos that contain explicit language, nudity, drug references, or depictions of drug use must be marked “Explicit.”
                <br /><br />
                Music Videos from Films. Music videos taken from musical films must contain a title version that refers to the film such as (From “Name of Film”).</p>
                <br />
                <h2 style={{ color: '#202124', fontFamily: "'DM Sans', sans-serif" }}>Music Video Specifications.</h2>
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>File Format:</span> QuickTime (.mov files)<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Codec :</span>  Apple PRO RES 422 (HQ)<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Size :</span> 1920×1080 pixels<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Video Bitrate :</span> ~220 Mb/s<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Framerate :</span> 24 or 25 fps<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Colorspace :</span> YUV 422<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Gamma Range :</span> Between  2.15 and 2.25<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Pixel ratio :</span> Ratio must be 1:1 (square pixel)<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Progressive :</span> The video must not be interlaced<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Black frame begining/ending :</span> The video must contain one black frame at the beginning and at the end<br />
                &#8226;&nbsp;<span style={{ fontWeight: 600 }}>Black bar scopes and logos :</span> No logo will be accepted Black bars accepted but we need crop size information (in pixels). * crop left: The number of whole pixels from the left of the encoded image to remove. * crop top: The number of whole pixels from the top of the encoded image to remove. * crop right: The number of whole pixels from the right of the encoded image to remove. * crop bottom: The number of whole pixels from the bottom of the encoded image to remove.
                Sound Quality : Codec – PCM Sampling frequency, 48 kHz Sample size, 16 bits Audio bitrate, ~1536 kb/s, 2 Channels (stereo)
                {/* <p style={{ marginTop: 20 }}>Format: mp3 or wav</p>
                <p style={{ marginTop: 10 }}><span style={{ fontWeight: 600 }}>Requirements:</span> Minimum of 16 bit, 44.1 Khz, stereo</p>
                <p><span style={{ fontWeight: 600 }}>Recommended</span> 24 bits, 48Khz or 24 bits 96Khz.</p> */}
            </CustomShowModal>
        </Grid >
    )
}

export default SongDetailForm
